import { render, staticRenderFns } from "./ApplicationWizard.vue?vue&type=template&id=508713fa&"
import script from "./ApplicationWizard.vue?vue&type=script&lang=js&"
export * from "./ApplicationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports